<ul>
  <li>
    <!-- Link interno con routerLink -->
    <ng-container *ngIf="item.url && !item.external">
      <li [routerLinkActive]="['active']" class="nav-item">
        <a class="nav-link"
           [target]="item.target ? '_blank' : '_self'"
           [routerLink]="[item.url]"
           (click)="toggleMenu($event)">
          
          <span class="coded-mtext">{{ item.title }}</span>
    
          <!-- Aggiungi l'indicatore solo se il link è attivo (controllato tramite la classe 'active') -->
          <span class="indicator" ></span>
        </a>
      </li>
    </ng-container>
    

    <!-- Titolo senza link -->
    <ng-container *ngIf="!item.url">
      <div class="menu-title">
   
        <span>{{ item.title }}</span>
      </div>
    </ng-container>

    <!-- Link esterno -->
    <ng-container *ngIf="item.url && item.external">
      <li [ngClass]="item.classes || ''">
        <a [href]="sanitizeURL(item.url)"
           [target]="item.target ? '_blank' : '_self'">
          <span *ngIf="item.icon" class="coded-micon">
            <span *ngIf="item.icon" class="coded-micon">
              <fa-icon [icon]="faDot" style="font-size: 8px;"></fa-icon>
            </span>
          </span>
          <span class="coded-mtext">{{ item.title }}</span>
        </a>
      </li>
    </ng-container>
  </li>
</ul>